import React from 'react';
import { useCurrency } from '../../context/CurrencyContext';
import { Icon } from '../ui/Icon';

const CURRENCIES = ['USD', 'ILS'] as const;

export const CurrencySwitcher: React.FC<{ compact?: boolean }> = ({ compact }) => {
  const ctx = useCurrency() as unknown as {
    currency?: string;
    setCurrency?: (c: string) => void;
  };
  const current = ctx.currency ?? 'USD';
  const idx = CURRENCIES.indexOf(current as (typeof CURRENCIES)[number]);
  const next = CURRENCIES[(idx + 1) % CURRENCIES.length];

  return (
    <button
      type="button"
      className="btn btn-ghost btn-sm"
      onClick={() => ctx.setCurrency?.(next)}
      aria-label={`Switch currency (current: ${current})`}
      title={`Switch to ${next}`}
    >
      <Icon name="dollar" size={14} />
      {!compact && <span style={{ fontSize: 12 }}>{current}</span>}
    </button>
  );
};

export default CurrencySwitcher;
